export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Help-Gray-87efc7cfa39ea3b961b556998e373cf1.svg";